export default __webpack_public_path__ + "static/media/sell_nft_over.fe2a70b7.png";